/*
 * Tagen Welma — native checkout submit fix.
 * The theme's checkout button is <button name="checkout" form="cart-form"> and
 * lives inside a modal <dialog> (the cart drawer), physically OUTSIDE the form.
 * On some mobile browsers (notably iOS Safari) a submit button that references
 * its form via the form= attribute from inside a dialog does not fire, so taps
 * do nothing. This delegated handler submits the associated form natively —
 * including the button's name="checkout" — so Shopify routes to native checkout.
 * No styling or markup is changed.
 */
(function () {
  'use strict';

  function resolveForm(btn) {
    var formId = btn.getAttribute('form');
    if (formId) {
      var byId = document.getElementById(formId);
      if (byId) return byId;
    }
    return btn.closest('form');
  }

  function submitCheckout(btn, form) {
    // Preferred: requestSubmit keeps the submitter's name/value (checkout) so
    // Shopify redirects to the hosted checkout. Supported iOS 16+ / modern browsers.
    if (typeof form.requestSubmit === 'function') {
      try {
        form.requestSubmit(btn);
        return;
      } catch (e) {
        /* fall through to legacy path */
      }
    }
    // Fallback: inject the checkout key as a hidden field, then submit natively.
    var hidden = form.querySelector('input[name="checkout"][data-tw-fallback]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.value = 'Checkout';
      hidden.setAttribute('data-tw-fallback', '');
      form.appendChild(hidden);
    }
    form.submit();
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('button[name="checkout"], #checkout');
      if (!btn) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      // Only handle real cart checkout submit buttons.
      if (btn.tagName !== 'BUTTON') return;
      var form = resolveForm(btn);
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      submitCheckout(btn, form);
    },
    true
  );
})();
